
/* injects from baggage-loader */

export const getSwarmSubscriptionRequestHorseRacing = (id) => {
    return {
        "source": "betting",
        "what": {
            "region": ["id", "name", "alias", "order"],
            "competition": "@count"
        },
        "where": {
            "game": {
                "@or": [
                    {"type": {"@in": [0, 2]}},
                    {"visible_in_prematch": 1, "type": 1}
                ]
            },
            "sport": {"id": +id}
        }
    };
};

export const getSwarmSubscriptionRequestHorseRacingCompetitions = ({regionId}) => {
    return {
        "source": "betting",
        "what": {
            "competition": ["id", "name", "order"]
        },
        "where": {
            "region": {"id": +regionId},
            "game":{"type":{"@in":[0,2]} }
        }
    };
};

export const getSwarmSubscriptionRequestHorseRacingTimes = ({compId}) => {
    return {
        "source": "betting",
        "what": {
            "game": [],
            "market": [],
            "event": []
        },
        "where": {
            "competition": {"id": +compId}
        }
    };
};

export const getSwarmSubscriptionRequestNextRacing = (id) => {
    return {
        "source": "betting",
        "what": {
            "region": ['id', "alias", "name"],
            "competition": ["id"],
            "game": ["start_ts", "id", "team1_name"]
        },
        "where": {
            "sport": {"id": +id}
        }
    };
};